<template>
  <div>
    <!-- EXCEL一键导入 -->
    <el-dialog :visible.sync="dialogVisible" width="480px" :title="$t('message.excelOneClickImport')">
      <div class="content">

        <div class="row">
          1、请先点击右边下载，下载当前待编辑的表格数据，在进行商品编辑，编辑完成在进行上传
          <div class="icon">
            <a href="https://rakumart-ps20.oss-ap-northeast-1.aliyuncs.com/202505/6836c1f6abc76/a/product_import.xlsx">
              <img src="@/assets/icon/import.svg" alt=""></a>
          </div>
        </div>
        <div class="row"> ２、请选择上传文件。</div>
        <div class="upload">
          <el-upload class="upload-demo" drag :action="baseURL + importPath"
            :show-file-list="false" :on-change="handleChange" :on-exceed="handleExceed" :limit="1"
            accept=".xls,.xlsx" :auto-upload="false" ref="upload" :before-upload="beforeUpload"
            :data="{ user_id: user_id, }" :headers="{
              AdminToken: 'Bearer ' + token
            }" :on-success="handleAvatarSuccess" :on-error="handleUploadError" :disabled="uploading">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em><br>*文件的格式是Xls， Xlsx<br>
            </div>
          </el-upload>
        </div>
        <p class="name">{{ name }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 导入 -->
        <el-button type="primary" :loading="uploading" @click="productListImport">{{
          $t("message.import")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入结果按照接口返回的成功行和失败行分别展示。 -->
    <el-dialog :visible.sync="resultVisible" width="1200px" :title="$t('message.productImportResult')"
      :close-on-click-modal="false" append-to-body>
      <div class="import-result">
        <div class="result-summary">
          <div class="summary-item total">
            <span>{{ $t('message.productImportTotal') }}</span>
            <strong>{{ importResult.total }}</strong>
          </div>
          <div class="summary-item success">
            <span>{{ $t('message.productImportUpdated') }}</span>
            <strong>{{ importResult.updated }}</strong>
          </div>
          <div class="summary-item failed">
            <span>{{ $t('message.productImportFailed') }}</span>
            <strong>{{ importResult.failed }}</strong>
          </div>
          <div class="summary-item skipped">
            <span>{{ $t('message.productImportSkipped') }}</span>
            <strong>{{ importResult.skipped }}</strong>
          </div>
          <div class="summary-item ai-fixed">
            <span>{{ $t('message.productImportAiFixed') }}</span>
            <strong>{{ importResult.ai_fixed }}</strong>
          </div>
        </div>

        <el-alert v-if="importResult.dry_run" class="result-alert"
          :title="$t('message.productImportDryRun')" type="info" :closable="false" show-icon />
        <el-alert v-for="(warning, index) in importResult.warnings" :key="`warning-${index}`"
          class="result-alert" :title="warning" type="warning" :closable="false" show-icon />

        <section class="result-section success-section">
          <h3>{{ $t('message.productImportSuccessDetails') }}</h3>
          <el-table :data="importResult.updated_rows" border stripe max-height="240"
            :empty-text="$t('message.productImportNoSuccess')">
            <el-table-column prop="row" :label="$t('message.productImportRow')" width="90" align="center" />
            <el-table-column prop="client_sku_code" :label="$t('message.productImportManagementNo')" min-width="220" />
            <el-table-column prop="sys_code" :label="$t('message.productImportSystemCode')" min-width="260" />
            <el-table-column prop="ai_fixed" :label="$t('message.productImportAiFixed')" width="100" align="center" />
          </el-table>
        </section>

        <section class="result-section failed-section">
          <h3>{{ $t('message.productImportFailedDetails') }}</h3>
          <el-table :data="importResult.errors" border stripe max-height="320"
            :empty-text="$t('message.productImportNoFailed')">
            <el-table-column prop="row" :label="$t('message.productImportRow')" width="90" align="center" />
            <el-table-column prop="column" :label="$t('message.productImportColumn')" width="150" />
            <el-table-column prop="raw" :label="$t('message.productImportRaw')" min-width="180" />
            <el-table-column prop="message" :label="$t('message.productImportReason')" min-width="280" />
            <el-table-column prop="expected" :label="$t('message.productImportExpected')" min-width="170" />
            <el-table-column prop="example" :label="$t('message.productImportExample')" min-width="160" />
          </el-table>
        </section>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resultVisible = false">{{ $t('message.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: String },
    importPath: { type: String, default: '/admin/product/productList/import' }
  },
  data() {
    return {
      token: localStorage.getItem('japan_access_token'),
      dialogVisible: false,
      name: '',
      uploading: false,
      resultVisible: false,
      importResult: {
        total: 0,
        updated: 0,
        skipped: 0,
        ai_fixed: 0,
        failed: 0,
        dry_run: false,
        warnings: [],
        errors: [],
        updated_rows: []
      }
    };
  },
  watch: {
    dialogVisible(value) {
      if (value) this.resetImportFile()
    }
  },
  methods: {
    // 弹窗只读取父级传入的 user_id，避免调用方通过 ref 直接修改 prop。
    open() {
      this.dialogVisible = true
    },
    resetImportFile() {
      this.name = ''
      this.uploading = false
      if (this.$refs.upload) this.$refs.upload.clearFiles()
    },
    // 保存
    productListImport() {
      if (!this.name) return this.$message.error(this.$t('message.productImportSelectFile'))
      this.uploading = true
      this.$refs.upload.submit()
    },
    // 点击或拖拽选择文件时保留 Element Upload 内部待提交文件。
    handleChange(file) {
      this.name = file.name
    },
    // 已有文件时再次选择或拖拽，直接替换为最新文件。
    handleExceed(files) {
      this.$refs.upload.clearFiles()
      this.$refs.upload.handleStart(files[0])
    },
    beforeUpload(file) {
      const extension = file.name.split('.').pop().toLowerCase()
      const valid = extension === 'xls' || extension === 'xlsx'
      if (!valid) {
        this.uploading = false
        this.$message.error(this.$t('message.productImportFileType'))
      }
      return valid
    },
    // 使用接口的 updated_rows 和 errors 原样生成成功、失败明细。
    handleAvatarSuccess(res) {
      const data = res.data || {}
      this.importResult = {
        total: Number(data.total) || 0,
        updated: Number(data.updated !== undefined ? data.updated : data.success) || 0,
        skipped: Number(data.skipped) || 0,
        ai_fixed: Number(data.ai_fixed) || 0,
        failed: Number(data.failed) || 0,
        dry_run: Boolean(data.dry_run),
        warnings: Array.isArray(data.warnings) ? data.warnings : [],
        errors: Array.isArray(data.errors) ? data.errors : [],
        updated_rows: Array.isArray(data.updated_rows) ? data.updated_rows : []
      }
      this.uploading = false
      this.dialogVisible = false
      this.resetImportFile()
      this.resultVisible = true
      this.$emit('search')
    },
    handleUploadError() {
      this.uploading = false
      this.$message.error(this.$t('message.productImportUploadFailed'))
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 0 12px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  img {
    margin-left: 24px;
  }
}

.upload {
  display: flex;
  justify-content: center;
  align-items: center;
}

.name {
  text-align: center;
  margin-top: 12px;
}

.import-result {
  max-height: 68vh;
  overflow-y: auto;
  padding-right: 4px;
}

.result-summary {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.summary-item {
  flex: 1;
  padding: 14px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f5f7fa;

  span,
  strong {
    display: block;
  }

  span {
    margin-bottom: 8px;
    color: #606266;
  }

  strong {
    color: #303133;
    font-size: 24px;
  }

  &.success {
    border-color: #b3e19d;
    background: #f0f9eb;

    strong {
      color: #67c23a;
    }
  }

  &.failed {
    border-color: #fab6b6;
    background: #fef0f0;

    strong {
      color: #f56c6c;
    }
  }
}

.result-alert {
  margin-bottom: 12px;
}

.result-section {
  margin-top: 18px;

  h3 {
    margin: 0 0 10px;
    padding-left: 10px;
    border-left: 4px solid #909399;
    color: #303133;
    font-size: 16px;
  }
}

.success-section h3 {
  border-left-color: #67c23a;
}

.failed-section h3 {
  border-left-color: #f56c6c;
}
</style>
